import "./Root.css.ts.vanilla.js";
var b = "_1buablx7", l = "_1buablx3", r = "_1buablx2", u = "_1buablx6", i = "_1buablx4", n = "_1buablx5", o = "_1buablx8", v = "_1buablx9", x = "_1buablx0", t = "_1buablx1";
export {
  b as alignBottom,
  l as alignCenter,
  r as alignLeft,
  u as alignMiddle,
  i as alignRight,
  n as alignTop,
  o as background,
  v as backgroundVideo,
  x as rootElement,
  t as verticalSnapScroll
};
